import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone'
import { ViewService } from '../../services/view/view.service';
import { AuthService } from '../../services/auth/auth.service';

interface MomentSettings {
  format?: string;
  withTime?: boolean;
  local?: boolean;
  tz?: string;
  includeOffset?: boolean;
  calendarDate?: boolean;
}

@Pipe({
  name: 'moment'
})
export class MomentPipe implements PipeTransform {
  constructor(private viewService: ViewService,
              private authService: AuthService) {}

  transform (value: number | string, settings: MomentSettings = {}) {
    if (settings.local === undefined) {
      settings.local = true;
    }
    if (!settings.format) {
      settings.format = this.viewService.conf.dateFormatWithWeekday;
      if (settings.withTime) {
        settings.format += ' ' + this.viewService.conf.timeFormat;
      } else if (settings.calendarDate) {
        settings.format = this.viewService.conf.timeFormat;
      }
    }
    if (!settings.tz) {
      settings.tz = this.authService.user.timezone;
    }
    let date: moment.Moment;
    if (typeof value === 'string' && isNaN(+value)) {
      date = moment.tz(value, settings.tz);
    } else {
      const offset = settings.includeOffset ? new Date().getTimezoneOffset() * -1 : 0;
      date = moment.utc(+value * 1000).utcOffset(offset);
      const dateIsDST = moment(date).tz(this.authService.user.timezone).isDST();
      if (settings.includeOffset && !moment().isDST() && dateIsDST) {
        date.add(1, 'hour');
      }
      if (settings.local && !settings.includeOffset) {
        date = date.add(2, 'hour');
      }
    }
    if (settings.calendarDate) {
      return date.calendar().split(' ')[0].replace(/\//g, '.') + ' ' + date.format(settings.format);
    }
    return date.format(settings.format);
  }
}
